export interface ISelectable
{
    select:() => ISelectable;
    unselect:() => ISelectable;
    toggleSelection:() => ISelectable;
    isSelected:() => boolean;
}

export class Selectable implements ISelectable
{
    private _isSelected:boolean = false;

    public select():ISelectable
    {
        this._isSelected = true;
        return this;
    }

    public unselect():ISelectable
    {
        this._isSelected = false;
        return this;
    }

    public toggleSelection():ISelectable
    {
        this._isSelected = !this._isSelected;
        return this;
    }

    public isSelected():boolean
    {
        return this._isSelected;
    };
}
